import React from "react"
import {
  NavItem,
  NavLink,
  UncontrolledDropdown,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Media,
  Badge
} from "reactstrap"
import PerfectScrollbar from "react-perfect-scrollbar"
import axios from "axios"
import * as Icon from "react-feather"
import classnames from "classnames"
import ReactCountryFlag from "react-country-flag"
import Autocomplete from "../../../components/@vuexy/autoComplete/AutoCompleteComponent"
import { useAuth0 } from "../../../authServices/auth0/auth0Service"
import { history } from "../../../history"
import { IntlContext } from "../../../utility/context/Internationalization"

const handleNavigation = (e, path) => {
  e.preventDefault()
  history.push(path)
}

const UserDropdown = props => {
  const { logout, isAuthenticated } = useAuth0()
  return (
    <DropdownMenu right>
      {/*<DropdownItem*/}
      {/*  tag="a"*/}
      {/*  href="#"*/}
      {/*  onClick={e => handleNavigation(e, "/pages/profile")}*/}
      {/*>*/}
      {/*  <Icon.User size={14} className="mr-50" />*/}
      {/*  <span className="align-middle">Edit Profile</span>*/}
      {/*</DropdownItem>*/}
      {/*<DropdownItem*/}
      {/*  tag="a"*/}
      {/*  href="#"*/}
      {/*  onClick={e => handleNavigation(e, "/email/inbox")}*/}
      {/*>*/}
      {/*  <Icon.Mail size={14} className="mr-50" />*/}
      {/*  <span className="align-middle">My Inbox</span>*/}
      {/*</DropdownItem>*/}
      {/*<DropdownItem*/}
      {/*  tag="a"*/}
      {/*  href="#"*/}
      {/*  onClick={e => handleNavigation(e, "/todo/all")}*/}
      {/*>*/}
      {/*  <Icon.CheckSquare size={14} className="mr-50" />*/}
      {/*  <span className="align-middle">Tasks</span>*/}
      {/*</DropdownItem>*/}
      {/*<DropdownItem*/}
      {/*  tag="a"*/}
      {/*  href="#"*/}
      {/*  onClick={e => handleNavigation(e, "/chat")}*/}
      {/*>*/}
      {/*  <Icon.MessageSquare size={14} className="mr-50" />*/}
      {/*  <span className="align-middle">Chats</span>*/}
      {/*</DropdownItem>*/}
      {/*<DropdownItem tag="a" href="#" onClick={e => handleNavigation(e, "/ecommerce/wishlist")}>*/}
      {/*  <Icon.Heart size={14} className="mr-50" />*/}
      {/*  <span className="align-middle">WishList</span>*/}
      {/*</DropdownItem>*/}
      {/*<DropdownItem divider />*/}
      <DropdownItem
        tag="a"
        onClick={() => props.logoutWithJWT()}
      >
        <Icon.Power size={14} className="mr-50" />
        <span className="align-middle">Log Out</span>
      </DropdownItem>
    </DropdownMenu>
  )
}

class NavbarUser extends React.PureComponent {
  state = {
    navbarSearch: false,
    langDropdown: false
  }

  componentDidMount() {
    axios.get("/api/main-search/data").then(({ data }) => {
      this.setState({ suggestions: data.searchResult })
    })
  }

  handleNavbarSearch = () => {
    this.setState({
      navbarSearch: !this.state.navbarSearch
    })
  }

  removeItem = id => {
    let cart = this.state.shoppingCart

    let updatedCart = cart.filter(i => i.id !== id)

    this.setState({
      shoppingCart: updatedCart
    })
  }


  render() {
    return (
      <ul className="nav navbar-nav navbar-nav-user float-right">
        <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
          <DropdownToggle tag="a" className="nav-link dropdown-user-link">
            <div className="user-nav d-sm-flex d-none">
              <span className="user-name text-bold-600">
                {this.props.userName}
              </span>
            </div>
            <span data-tour="user">
              <img
                src={this.props.userImg}
                className="round"
                height="40"
                width="40"
                alt="avatar"
              />
            </span>
          </DropdownToggle>
          <UserDropdown {...this.props} />
        </UncontrolledDropdown>
      </ul>
    )
  }
}
export default NavbarUser
